// GA4's two video events (Seán, 2026-11-05; fullstack claude/ANALYTICS.md § Video events):
//   video_start    once per page view, as playback first runs with the page visible
//   video_watched  once per page view, after 60 s of playback with the page visible
// Both with video_id (the page's hash) and video_access (public, free or locked). Seeks, a
// background tab and a jump to another version don't count towards the 60 s; pause and resume
// don't send again. GA's own browser id only, never a Clerk id. gtag is there on the live site
// only (main.js), and in tests as a recorder (fullstack tests/e2e/helpers/browser.js); elsewhere
// nothing is sent. Watch time and completion stay with Vimeo's own analytics
import {getVideoStatus} from "@/components/Video/videoCards";

const WATCHED_SECONDS = 60;
// the most playback between two of the player's timeupdates (about 4 a second); more is a seek,
// another video loaded, or a tab the browser throttled
const MAX_STEP = 2;
const ACCESS = {public: "public", free: "free"}; // else locked (restricted, unreleased)

// the page view's playback so far: a new path is a new page view; the player itself can be
// rebuilt within one (a dialog's hash), so this lives outside it
let pageView = {path: "", seconds: 0, sent: new Set()};

function getPageView() {
  const path = window.location.pathname;
  if (pageView.path !== path) pageView = {path, seconds: 0, sent: new Set()};
  return pageView;
}

function sendOnce(name, {id, record}) {
  const view = getPageView();
  if (view.sent.has(name)) return;
  view.sent.add(name);
  const access = ACCESS[getVideoStatus(record)] || "locked";
  window.gtag?.("event", name, {video_id: id, video_access: access});
}

function addPlayback(step, video) {
  const view = getPageView();
  view.seconds += step;
  sendOnce("video_start", video);
  if (view.seconds >= WATCHED_SECONDS) sendOnce("video_watched", video);
}

// once the player is ready; getVideo: the page's video now, {id: its hash, record: its entry in
// the catalogue}
export function followVideoAnalytics(player, getVideo) {
  let lastSeconds = null;
  player.on("timeupdate", ({seconds}) => {
    const step = lastSeconds === null ? 0 : seconds - lastSeconds;
    lastSeconds = seconds;
    if (document.visibilityState !== "visible" || step <= 0 || step > MAX_STEP) return;
    addPlayback(step, getVideo());
  });
  player.on("seeked", ({seconds}) => (lastSeconds = seconds));
}
